import {Component} from 'react';
import PropTypes from 'prop-types';

import {connect} from '@stubhub/react-store-provider';

import controller from './controller';
import cxsFactory from './cxs';

export class ThemeProvider extends Component {
  constructor(props, context) {
    super(props, context);
    const {cache, rules, updateThemeProvider} = props;
    this.themeProvider = new cxsFactory(cache, rules, updateThemeProvider);
  }

  static propTypes = {
    theme: PropTypes.object,
    cache: PropTypes.object,
    rules: PropTypes.array,
    updateTheme: PropTypes.func.isRequired,
    updateThemeProvider: PropTypes.func.isRequired,
    children: PropTypes.node,
  };

  static childContextTypes = {
    theme: PropTypes.object,
    themeProvider: PropTypes.func,
    updateTheme: PropTypes.func,
  };

  getChildContext() {
    const {theme, updateTheme} = this.props;

    return {theme, themeProvider: this.themeProvider, updateTheme};
  }

  render() {
    const {children} = this.props;

    return children;
  }
}

export default connect(controller)(ThemeProvider);
